import {
  Box,
  Button, Input, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
  Select,
  Text,
  useDisclosure,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { Link as RLink } from 'react-router-dom';
import {
  useGetTemplatesQuery, useSaveAsTemplateMutation,
} from '../../Services/templates';

const RadioSelect = ({ selected, onChange }) => {
  const { data: templates } = useGetTemplatesQuery();
  const ref = useRef();
  const handleChange = (e) => {
    const { value } = e.target;
    console.log(value);
    onChange({ type: 'select', value });
  };
  useEffect(() => {
    if (!selected) ref.current.value = 'placeholder';
  }, [selected]);
  return (
    <Box onClick={() => handleChange({ target: { value: ref.current.value } })} cursor="pointer">
      <Box
        as="span"
        w="12px"
        h="12px"
        border="4px solid"
        display="inline-block"
        borderRadius="50%"
        mr="2"
        borderColor={selected ? 'blue.500' : 'gray.500'}
      />
      Choose an existing template
      <Select onChange={handleChange} ml="4" ref={ref} cursor="pointer" isRequired opacity={selected ? 1 : 0.4}>
        <option disabled value="placeholder">Select template</option>
        {selected && (templates || []).map((template) => (
          <option key={template.id} value={template.id}>{template.name}</option>
        ))}
      </Select>
    </Box>
  );
};

const RadioInput = ({ selected, onChange }) => {
  const ref = useRef();
  const handleChange = (e) => {
    const { value } = e.target;
    console.log(value);
    onChange({ type: 'input', value });
  };
  return (
    <Box onClick={() => handleChange({ target: { value: ref.current.value } })} cursor="pointer">
      <Box
        as="span"
        w="12px"
        h="12px"
        border="4px solid"
        display="inline-block"
        borderRadius="50%"
        mr="2"
        borderColor={selected ? 'blue.500' : 'gray.500'}
      />
      Create new template
      <Input ml="4" onChange={handleChange} placeholder="Template name" ref={ref} color={selected ? 'gray.600' : 'gray.400'} />
    </Box>
  );
};

const SaveAsTemplate = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [value, setValue] = useState({ type: 'input', value: '' });
  const [saveTemplate, { isLoading }] = useSaveAsTemplateMutation();
  const toast = useToast();

  const handleSaveTemplate = async () => {
    console.log('aa', value);
    const t = await saveTemplate({
      type: value.type === 'input' ? 'new' : 'update',
      value: value.value,
    }).unwrap();
    toast({
      title: 'Template saved',
      description: (
        <Text>
          Template must be published
          <Link ml="1" as={RLink} to={`/templates/${t.id}/edit`} textDecor="underline"><i>Go to template</i></Link>
        </Text>
      ),
      status: 'success',
      variant: 'left-accent',
      isClosable: true,
      position: 'top',
      duration: 3000,
    });
    onClose();
  };

  return (
    <>
      <Button onClick={onOpen} size="sm" colorScheme="blue" variant="outline" mb="3">Save as template</Button>
      <Modal isOpen={isOpen} onClose={onClose} size="2xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="gray.600" pb="2">Save template as...</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="14px" color="gray.600">
            <Text mb="4" fontWeight="bold">Template must be published after save</Text>
            <VStack alignItems="start" gap="4">
              <RadioSelect onChange={setValue} selected={value.type === 'select'} />
              <RadioInput onChange={setValue} selected={value.type === 'input'} />
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button
              size="sm"
              variant="solid"
              colorScheme="blue"
              mr={3}
              onClick={handleSaveTemplate}
              isLoading={isLoading}
              isDisabled={!value.value || value.value === 'placeholder'}
            >
              Save
            </Button>
            <Button size="sm" variant="outline" isDisabled={isLoading} onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SaveAsTemplate;
